import {
  EB,
  BM,
  CM,
  CTFM,
  CW,
  EASYBIB,
  BIBME,
  CITATION_MACHINE,
  CITE_THIS_FOR_ME,
  CHEGG,
} from '@chegg-wt/core/constants/site'

export const EVENT_TYPES = {
  CLICKSTREAM_VIEW: 'clickstream_view',
  CLICKSTREAM_INTERACTION: 'clickstream_interaction',
  CLICKSTREAM_NOTIFICATIONS: 'clickstream_notifications',
  CARD_ENGAGEMENT: 'card_engagement',
  // Sending the `PAPER_READY` event as type:paperUpload will ensure it goes to the same DB index as
  // other paper activity, allowing us to better view it alongside all paper events.
  PAPER_READY: 'paper_upload',
  // Similarly, sending paper check events to paperUpload end point for data processing convenience
  PAPER_CHECK_START: 'paper_upload',
  PAPER_CHECK_END: 'paper_upload',
} as const

export const viewExperienceMap = {
  [EASYBIB]: EB,
  [BIBME]: BM,
  [CITATION_MACHINE]: CM,
  [CHEGG]: CW,
  [CITE_THIS_FOR_ME]: CTFM,
} as const
